import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PlatformSettingsFormService } from './application/platform-settings-form.service';
import { PlatformSettingsEffects } from './state/platform-settings.effects';
import { PlatformSettingsFacade } from './state/platform-settings.facade';
import { featureKey, reducer } from './state/platform-settings.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(featureKey, reducer),
        EffectsModule.forFeature([PlatformSettingsEffects])
    ],
    providers: [PlatformSettingsFacade, PlatformSettingsFormService]
})
export class PlatformSettingsDomainModule {}
